module.exports = __webpack_public_path__ + "img/pomoc-logowanie-1.bf98e362.png";